<template>
    <section class="search-header">
        <div class="container">
            <div class="search-header__wrapper">
                <h3 class="search-header__heading">Wyniki wyszukiwania:</h3>
                <div class="search-header__form">
                    <input type="text"
                        class="search-header__input"
                        v-model="query"
                        @keyup.enter="goToSearch"
                    >
                    <IconSearch class="search-header__submit" @click.stop.prevent="goToSearch"></IconSearch>
                    <IconCloseWhite class="search-header__hamburger" v-if="query" @click="clear"></IconCloseWhite>
                </div>
                <p class="search-header__results">liczba wyników: <span class="search-header__count">{{ searchList.total_count || 0 }}</span></p>
            </div>
        </div>
    </section>
</template>

<script>
import IconCloseWhite from "../elements/icons/IconCloseWhite.vue";
import IconSearch from "../elements/icons/IconSearch.vue";
export default {
    name: "SearchHeader",
    props: {
        searchList: {
            type: Object,
            default: () => {},
        },
        searchQuery: {
            type: String
        }
    },
    data() {
        return {
            query: '',
        };
    },
    components: {
        IconCloseWhite,
        IconSearch
    },
    watch: {
        searchQuery() {
            this.query = this.searchQuery;
        }
    },
    methods: {
        goToSearch() {
            if(this.query) {
                this.$router.push({
                    name: "Search",
                    path: "/wyszukiwarka",
                    query: { query: `${this.query}` },
                });
            }
        },
        clear() {
            this.query = '';
        }
    },
    mounted() {
        if(this.searchQuery) {
            this.query = this.searchQuery;
        }
    }
};
</script>
